import PropTypes from 'prop-types';
import React from 'react';
import InputCheckboxComponent from './inputs/InputCheckboxComponent';
import InputRadioButtonComponent from './inputs/InputRadioButtonComponent';
import InputTextComponent from './inputs/InputTextComponent';
import PhoneNumberComponent from './PhoneNumberComponent';
import SimpleReactValidator from './validator';
import InputDropdownComponent from './inputs/InputDropdownComponent';
import BannerComponent from './BannerComponent';

class FuelCardComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const {
            idPrefix,
            translation,
            element,
            stateField,
            fuelCardTypeOptions,
            fuelCardAppRoleOptions,
            handleChange,
            validator,
            disabled,
            handleFuelCardTypeChange,
            phoneCodeOptions,
            chosenOfferType,
            cardOptions,
            handleChoosePlasticCardOption,
        } = this.props;
        element.fuelCardPlastic ? (element.cost = 10) : (element.cost = 0);
        element.cardNumber = idPrefix + 1;
        element.fuelCardVirtual = true;
        element.phoneNumberCode = element.phoneNumberCode === undefined ? phoneCodeOptions[0] : element.phoneNumberCode;
        return (
           
            <div className=''>
                <div className='row'>
                    <div className='header'>{`1. ${translation('autoRegistration.chooseCardType')}`}</div>
                    <InputRadioButtonComponent
                        id={`${idPrefix}fuelCardType`}
                        name='fuelCardType'
                        colClass='col-12'
                        value={element.fuelCardType}
                        label={translation('autoRegistration.cardType')}
                        showLabel={false}
                        viewMode={'EDIT'}
                        labelOnRight
                        options={fuelCardTypeOptions}
                        valueLabel='label'
                        itemColClass={'col-md-3 col-sm-6'}
                        validators='required'
                        valueKey='enumValue'
                        stateField={stateField}
                        onChange={handleChange}
                        validator={validator}
                        disabled={disabled}
                        description='description'
                        showDescription={true}
                        descriptionClassName='p-radiobutton-label'
                        onAfterStateChange={handleFuelCardTypeChange}
                    />
                    {this.props.bank? null : <div className='header'>{`2. ${translation('autoRegistration.cardSettings')}`}</div>}
                    {this.props.bank? null : <div className='row checkbox-fuel-card-row'>
                        <InputRadioButtonComponent
                            id={`${idPrefix}fuelCardAppRole`}
                            name='fuelCardAppRole'
                            label={translation('autoRegistration.appRole')}
                            colClass='col-md-6 col-sm-12'
                            value={element.fuelCardAppRole}
                            viewMode={'EDIT'}
                            labelOnRight
                            options={fuelCardAppRoleOptions}
                            valueLabel='label'
                            itemColClass={'col-md-6 col-sm-6'}
                            validators='required'
                            valueKey='enumValue'
                            stateField={stateField}
                            onChange={handleChange}
                            validator={validator}
                            disabled={disabled}
                            required
                            renderRequired
                        />
                        <div className='col-md-6' style={{display: 'flex', flexWrap: 'wrap'}} /*placeholder*/>
                            <div className='col-12 p-label'>{translation('autoRegistration.fuelCardType')}</div>
                            <div className='col-md-6 checkbox-fuel-card'>
                                <InputCheckboxComponent
                                    id={`${idPrefix}fuelCardVirtual`}
                                    name='fuelCardVirtual'
                                    label={translation('autoRegistration.cardVirtual')}
                                    labelOnRight
                                    value={element.fuelCardVirtual}
                                    stateField={stateField}
                                    onChange={handleChange}
                                    validator={validator}
                                    viewMode='NEW'
                                    validators='not_required'
                                    colClass='col-12'
                                    disabled
                                    checked
                                    labelClassName='checkbox-label-fuel-card'
                                    valueLabel='label'
                                    valueKey='enumValue'
                                />

                            </div>
                            <div className='col-md-6 checkbox-fuel-card'>
                                <InputCheckboxComponent
                                    id={`${idPrefix}fuelCardPlastic`}
                                    name='fuelCardPlastic'
                                    label={translation('autoRegistration.cardPlastic')}
                                    labelOnRight
                                    value={element.fuelCardPlastic}
                                    stateField={stateField}
                                    onChange={handleChange}
                                    validator={validator}
                                    viewMode='NEW'
                                    validators='not_required'
                                    colClass='col-12 '
                                    labelClassName='checkbox-label-fuel-card'
                                    valueLabel='label'
                                    valueKey='enumValue'
                                />
                                <div className='col-md-12'>
                                    <InputRadioButtonComponent
                                        id={`${idPrefix}cardOption`}
                                        name='cardOption'
                                        colClass='col-12 fuel-card-opt'
                                        value={element.cardOption}
                                        label={translation('autoRegistration.cardType')}
                                        showLabel={false}
                                        viewMode={'EDIT'}
                                        labelOnRight
                                        options={cardOptions}
                                        valueLabel='label'
                                      // itemColClass={'col-md-6 col-sm-6'}
                                        validators='required'
                                         valueKey='enumValue'
                                        stateField={stateField}
                                        onChange={handleChange}
                                        validator={validator}
                                        disabled={disabled}
                                        description='description'
                                        showDescription={true}
                                        descriptionClassName='p-radiobutton-label'
                                        onAfterStateChange={handleChoosePlasticCardOption}
                                        required
                                        rendered={element.fuelCardPlastic && chosenOfferType === 'PREPAID' }
                                    />

                            </div>
                            </div>
                            <div colClass='col-md-12'>
                                {element.fuelCardPlastic === false ?
                                 <div className='fleet-good-group-banner-virtual-only'>
                                 <BannerComponent
                                     key={'header-banner'}
                                     subLabel={translation('autoRegistration.virtualCardTypeInfoBanner')}
                                     iconSvg='ico_blue_banner_icon'
                                     iconSide='left'
                                     variant='white-banner'
                                 ></BannerComponent>
                                 </div>     : null
                            }



                            </div>

                        </div>
                    </div>}
                    <div className='header'>{this.props.bank? `2. ${translation('autoRegistration.requiredData')}` : `3. ${translation('autoRegistration.requiredData')}`}</div>
                    {this.props.bank?
                                    null :
                    <PhoneNumberComponent
                        id={`${idPrefix}phoneNumber-component`}
                        nameCode='phoneNumberCode'
                        namePhoneNumber='phoneNumberValue'
                        labelCode={translation('cards.phoneNumberCode')}
                        labelPhoneNumber={translation('autoRegistration.phone')}
                        colClass={element?.fuelCardType === 'VEHICLE_PERSON' ? 'col-xl-3 col-lg-3 col-md-8 col-sm-12' : 'col-xl-4 col-lg-4 col-md-8 col-sm-12'}
                        phoneCodeValue={element?.phoneNumberCode}
                        phoneNumberValue={element?.phoneNumberValue}
                        telephoneCodeOptions={phoneCodeOptions}
                        value={element?.phoneNumber}
                        viewMode='NEW'
                        onChange={handleChange}
                        validator={validator}
                        renderRequired={!element.fuelCardPlastic}
                        required={!element.fuelCardPlastic}
                        stateField={stateField}
                        inputTextColClass={element?.fuelCardType === 'VEHICLE_PERSON' ? 'col-5' : 'col-6'}
                    />
                }
                    <InputTextComponent
                        id={`${idPrefix}fuelCardName`}
                        name='fuelCardName'
                        label={translation('autoRegistration.fuelCardName')}
                        colClass={element?.fuelCardType === 'VEHICLE_PERSON' ? 'col-xl-3 col-lg-3 col-md-8 col-sm-12' : 'col-xl-4 col-lg-4 col-md-8 col-sm-12'}
                        value={element?.fuelCardName}
                        stateField={stateField}
                        onChange={handleChange}
                        viewMode='NEW'
                        max={32}
                        validator={validator}
                        validators='required|alpha_space_dash|max:32'
                        disabled={disabled}
                        validateViewMode
                        required
                        renderRequired
                        rendered={element?.fuelCardType === 'PERSON' || element?.fuelCardType === 'VEHICLE_PERSON'}
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻ\s-]*$/i}
                    />
                    <InputTextComponent
                        id={`${idPrefix}registrationNumber`}
                        name='registrationNumber'
                        label={translation('autoRegistration.RegistrationNumber')}
                        colClass={element?.fuelCardType === 'VEHICLE_PERSON' ? 'col-xl-3 col-lg-3 col-md-8 col-sm-12' : 'col-xl-4 col-lg-4 col-md-8 col-sm-12'}
                        value={element?.registrationNumber}
                        stateField={stateField}
                        onChange={handleChange}
                        viewMode='NEW'
                        validator={validator}
                        validators='required|alpha_num|max:10'
                        disabled={disabled}
                        validateViewMode
                        required
                        renderRequired
                        rendered={element?.fuelCardType === 'VEHICLE' || element?.fuelCardType === 'VEHICLE_PERSON'}
                        forceUpperCase
                        keyfilter={/^[A-Z0-9]*$/i}
                    />
                    <InputDropdownComponent
                        id={`${idPrefix}vehicleType`}
                        name='vehicleType'
                        label={translation('order-card.vehicleType')}
                        colClass={element?.fuelCardType === 'VEHICLE_PERSON' ? 'col-xl-3 col-lg-2 col-md-8 col-sm-12' : 'col-xl-4 col-lg-4 col-md-8 col-sm-12'}
                        value={element?.vehicleType}
                        viewMode='EDIT'
                        validator={validator}
                        validators='required'
                        stateField={stateField}
                        enumMode={true}
                        options={this.props.vehicleTypeOpt}
                        onChange={(a,b,c,d,e) => handleChange(a, b, c, d, e)}
                        optionLabel='label'
                        optionValue='code'
                        dataKey='code'
                        renderRequired
                        validateViewMode
                    />

                    {this.props.bank ?  <div className='header'>{`3. ${translation('autoRegistration.hybrdCardHeader')}`}</div> : null}
                    {this.props.bank ? <InputTextComponent
                       id={`${idPrefix}hybridCardId`}
                       name='hybridCardId'
                       label={translation('autoRegistration.hybridCardId')}
                       colClass={'col-xl-4 col-lg-4 col-md-8 col-sm-12'}
                       value={element?.hybridCardId}
                       stateField={stateField}
                       onChange={handleChange}
                       viewMode='NEW'
                       validator={validator}
                       validators='required|alpha_num|max:10|min:10'
                       disabled={disabled}
                       validateViewMode
                       required
                       renderRequired
                       //rendered={"gdy hybrydowa"}
                       forceUpperCase
                       keyfilter={/^[A-Z0-9]*$/i}
                   /> : null }

                </div>

            </div>
        );
    }
}

FuelCardComponent.defaultProps = {
    element: null,
    idPrefix: '',
    viewMode: 'NEW',
    stateField: 'element',
    colClass: 'col-12',
    disabled: false,
    bank: false,
};

FuelCardComponent.propTypes = {
    element: PropTypes.object,
    idPrefix: PropTypes.number,
    stateField: PropTypes.string,
    viewMode: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    validator: PropTypes.instanceOf(SimpleReactValidator).isRequired,
    fuelCardTypeOptions: PropTypes.array.isRequired,
    fuelCardAppRoleOptions: PropTypes.array.isRequired,
    phoneCodeOptions: PropTypes.array.isRequired,
    translation: PropTypes.func.isRequired,
    handleFuelCardTypeChange: PropTypes.func,
    chosenOfferType: PropTypes.string,
    cardOptions: PropTypes.array.isRequired,
    handleChoosePlasticCardOption: PropTypes.func,
    vehicleTypeOpt: PropTypes.func,
    bank: PropTypes.bool,
};

export default FuelCardComponent;
